import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {URL_AUTH_LOGIN} from "../../mock/page_urls";

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to={URL_AUTH_LOGIN} />
    </Routes>
  )
}
